import { CreatureSvg } from './CreatureSvg';
import { RarityPill } from './RarityPill';
import { getSpecies } from '@/constants/rewards';
import type { Rarity } from '@/types/rewards';

interface LockedCardProps {
  speciesId: string;
}

export function LockedCard({ speciesId }: LockedCardProps) {
  const species = getSpecies(speciesId);
  const rarity = (species?.rarity ?? 'common') as Rarity;

  return (
    <div
      className="flex flex-col items-center rounded-2xl bg-[#FAF3E5] p-5 border border-stone-200 min-h-[200px] justify-center"
      aria-hidden="true"
    >
      <div className="flex items-center justify-center w-[120px] h-[120px] mb-3">
        <CreatureSvg speciesId={speciesId} size={100} silhouette />
      </div>
      <p className="text-base font-display text-stone-300 mb-1">???</p>
      <RarityPill rarity={rarity} />
    </div>
  );
}
